<template>
  <div>
    <div class="BlockList">
      <div class="BlockList-W">
        <div class="BlockList_Inp"><Homseach></Homseach></div>
        <div class="Blockbox">
          <div class="Blockboxli box1">
            <div class="Blocktit">Total Collections</div>
            <div class="Blockcon"><span v-if="totalNFTs>999">{{ Number(totalNFTs).toLocaleString() }}</span><span v-else>{{ totalNFTs }}</span></div>
          </div>
          <div class="Blockboxli box2">
            <div class="Blocktit">Total NFTs</div>
            <div class="Blockcon"><span v-if="collections>999">{{ Number(collections).toLocaleString() }}</span><span v-else>{{ collections }}</span></div>
          </div>
          <div class="Blockboxli box3">
            <div class="Blocktit">Total NFT Holders</div>
            <div class="Blockcon"><span v-if="holders>999">{{ Number(holders).toLocaleString() }}</span><span v-else>{{ holders }}</span> </div>
          </div>
          <div class="Blockboxli box4">
            <div class="Blocktit">NFTs Created in last 30 days</div>
            <div class="Blockcon"><span v-if="pastMonthMintNFTCount>999">{{ Number(pastMonthMintNFTCount).toLocaleString() }}</span><span v-else>{{ pastMonthMintNFTCount }}</span>  </div>
          </div>
        </div>
        <div>
          <TokensList :nftList="nftList" :totalNFTs="nftCount" :PaginationIndex="PaginationIndex"   @getDatepage="getDatepage" @search="search"></TokensList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSubStr } from "@/utils/utils";
import { GetnftList } from "@/assets/server/api";
import Listbox from "@/components/pc/Listbox.vue";
import Homseach from "@/components/pc/serch.vue";
import Homeinput from "../Home/Home_input.vue";
import TokensList from "./NFTsList.vue";
export default {
  data() {
    return {
      PaginationIndex:1,
      collections: '',
      holders: '',
      nftList:[] ,
      pastMonthMintNFTCount: '',
      totalNFTs: '',
      nftCount:"",
      contractName:'',
      imgurl:require('@/assets/pc/Index/indexlogo.png'),
      imgurl1:require('@/assets/pc/Index/indexlogo.png'),
      // PaixuImg: "",
      // PaixuImg1: "",
      // ImgUrl: require("@/assets/m/home/TopValidators1.png"),
      // ImgUrl2: require("@/assets/m/home/TopValidators2.png"),
      // ImgUrl3: require("@/assets/m/home/TopValidators3.png"),
    };
  },
  components: {
    Homeinput,
    Homseach,
    Listbox,
    TokensList,
  },
  created() {
    // this.PaixuImg=this.ImgUrl;
    // this.PaixuImg1=this.ImgUrl;
  },
  mounted(){
    this.getContractTxList();
  },
  methods: {
    search(val){
      this.contractName=val;
      this.PaginationIndex=1;
      this.getContractTxList();
    },
    getDatepage(val){
      this.PaginationIndex=val;
      this.getContractTxList();
    },
    check_is_img(url) { return (url.match(/\.(jpeg|jpg|gif|png|GIF|PNG|JPG|JPEG|SVG|svg)$/) != null)},
    async getContractTxList() {
      let formData = new FormData();
      let params = {
        pageNum: this.PaginationIndex,
        pageSize: 20,
        contractName:this.contractName
      };
    //  console.log(params);
      let item = params;

      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await GetnftList(formData);
     // console.log(res);
      // collections: '',
      // holders: '',
      // nftList:[] ,
      // pastMonthMintNFTCount: '',
      // totalNFTs: '',
      this.collections= res.result.collections;
      this.holders=res.result.holders;
      this.nftList=res.result.nftList;
      for(var i=0;i<this.nftList.length;i++){
      // console.log(this.check_is_img(this.nftList[i].logo))
        if(this.nftList[i].logo=="" || this.check_is_img(this.nftList[i].logo)==false){
          this.nftList[i].logo=this.imgurl1;
        }
        if(this.nftList[i].contractName.trim()==''|| this.nftList[i].contractName==null){
          this.nftList[i].contractName=getSubStr(this.nftList[i].contractAddress,0,3);
        }
      }
      //console.log( this.nftList);
      this.pastMonthMintNFTCount=res.result.pastMonthMintNFTCount;
      this.totalNFTs=res.result.totalNFTs;
      this.nftCount=res.result.nftCount;

    },
  },
};
</script>

<style lang="less" scoped>
.BlockList {
  width: 100%;
  background: #13161b;
  .BlockList-W {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 36px;
    background: #13161b;
    .BlockList_Inp {
      padding: 40px 0;
    }
    .Blockbox {
      margin-bottom: 20px;
      display: flex;
      .box1 {
        width: 262px !important;
      }
      .box2 {
        width: 204px !important;
      }
      .box3 {
        width: 267px !important;
      }
      .box4 {
        width: 367px;
      }
      .Blockboxli {
        height: 120px;
        background: #0b0c0f;
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        margin-right: 20px;
        .Blocktit {
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);
          line-height: 17px;
          margin-top: 30px;
          margin-left: 40px;
        }
        .Blockcon {
          height: 35px;
          font-size: 24px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #00e79a;
          line-height: 35px;
          margin-top: 8px;
          margin-left: 40px;
        }
      }
    }
  }
}
</style>
